/** Matches promotions PromotionKind */
export enum PromotionKind {
  Incentive = "INCENTIVE",
  Rebate = "REBATE",
}

export type Incentive = {
  id: number;
  kind: PromotionKind.Incentive;
  title: string;
  description: string;
  details: string;
};

export type Rebate = {
  id: number;
  kind: PromotionKind.Rebate;
  title: string;
  description: string;
  details: string;
};

/** Matches PromoCodeSerializer */
export interface IPromoCode {
  id: number;
  incentive: null | number;
  rebate: null | number;
  code: string;
}

/** matches promotions CommonPromotionSerializer / PromotionDetail */
export type Promotion = Incentive | Rebate;

/** Matches promotions IncentiveStatus  */
export enum IncentiveStatus {
  Live = "LIVE",
  Upcoming = "UPCOMING",
  Expired = "EXPIRED",
  Inactive = "INACTIVE",
}
